/**
 * @generated SignedSource<<de2d6b1c069b966f71bd97e361902b19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderApp_paymentLink$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Order_paymentLink">;
  readonly " $fragmentType": "OrderApp_paymentLink";
};
export type OrderApp_paymentLink$key = {
  readonly " $data"?: OrderApp_paymentLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderApp_paymentLink">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderApp_paymentLink",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Order_paymentLink"
    }
  ],
  "type": "PaymentLink",
  "abstractKey": null
};

(node as any).hash = "f6f9339a4bb584f30833ba5677cdb042";

export default node;
